import React from 'react';

export default function TotalsSection({
  totals,
  fmtUSD,
  invoiced,
  paid,
  amountDue,
  dueLabel = 'Amount Due',
  showDepositDue = false,
  depositPct = null,
}) {
  const subtotal = Number(totals.subtotal) || 0;
  const tax = Number(totals.tax) || 0;
  const depositDue = Number(totals.depositDue) || 0;
  const total = Number(totals.grandTotal ?? totals.total ?? subtotal + tax) || 0;
  const hasDueDetails =
    Number.isFinite(Number(paid)) || Number.isFinite(Number(amountDue));

  const depositLabel =
    depositPct != null && Number.isFinite(Number(depositPct)) && Number(depositPct) > 0
      ? `Deposit Due (${Number(depositPct)}%)`
      : 'Deposit Due';

  return (
    <div className="totals-card if-card">
      <div className="tot-row">
        <span>Subtotal</span>
        <span>{fmtUSD(subtotal)}</span>
      </div>

      <div className="tot-row">
        <span>Sales Tax</span>
        <span>{fmtUSD(tax)}</span>
      </div>

      <div className="tot-row total">
        <span>Total</span>
        <strong>{fmtUSD(total)}</strong>
      </div>

      {showDepositDue && (
        <div className="tot-row">
          <span>{depositLabel}</span>
          <span>{fmtUSD(depositDue)}</span>
        </div>
      )}

      {Number(invoiced) > 0 && (
        <div className="tot-row">
          <span>Invoiced</span>
          <span>{fmtUSD(Number(invoiced))}</span>
        </div>
      )}

      {hasDueDetails && (
        <>
          <div className="tot-row">
            <span>Paid</span>
            <span>{fmtUSD(Number(paid) || 0)}</span>
          </div>
          <div className="tot-row total">
            <span>{dueLabel}</span>
            <strong>{fmtUSD(Number(amountDue) || 0)}</strong>
          </div>
        </>
      )}
    </div>
  );
}
